import { render, staticRenderFns } from "./crudLostMotive.vue?vue&type=template&id=6c3c7ce3&"
import script from "./crudLostMotive.vue?vue&type=script&lang=js&"
export * from "./crudLostMotive.vue?vue&type=script&lang=js&"
import style0 from "./crudLostMotive.vue?vue&type=style&index=0&id=6c3c7ce3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports